const FONTS_FAMILY = {
  body: 'Roboto',
  title: 'Roboto',
};

export default FONTS_FAMILY